//Added for reason issue
import React from 'react';

export const reasonRenderer = (value) => {
    return (
       <>
        <div style={{"width":"90%"}}>{value}</div>
         </>
    )
  };